import { MarketIndexes } from '../api/v1/market'
import {
  PRIMARY_CURRENCY,
  PRIMARY_CURRENCY_PRICE,
} from '../constants/currencies'
import { Ether, TokenSymbol } from '../types'

export function getOraclePriceFromIndexes(
  indexes: MarketIndexes,
  baseCurrency: TokenSymbol,
): Ether {
  if (baseCurrency === PRIMARY_CURRENCY) {
    return PRIMARY_CURRENCY_PRICE.toString()
  }
  const index = indexes[baseCurrency]
  if (index && index[1]) {
    return String(index[1])
  }
  return '0'
}
